import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AdlinkModule } from './adlink/adlink.module';
import { DashboardModule } from './dashboard/dashboard.module';
import { DiscountsModule } from './discounts/discounts.module';
import { EmailsModule } from './emails/emails.module';
import { EventsModule } from './events/events.module';
import { GeneralSettingsModule } from './general-settings/general-settings.module';
import { GroupLinksModule } from './group-links/group-links.module';
import { PrivateComponent } from './private.component';
import { RedisManagerModule } from './redis-manager/redis-manager.module';
import { ServiceChargesModule } from './service-charges/service-charges.module';
import { TransactionsModule } from './transactions/transactions.module';
import { UpgradeModule } from './upgrade/upgrade.module';
import { UpsellModule } from './upsell/upsell.module';
import { UsersModule } from './users/users.module';
@NgModule({
  imports: [
    AdlinkModule,
    CommonModule,
    DashboardModule,
    DiscountsModule,
    EmailsModule,
    EventsModule,
    GeneralSettingsModule,
    RedisManagerModule,
    RouterModule,
    ServiceChargesModule,
    TransactionsModule,
    UpsellModule,
    UpgradeModule,
    GroupLinksModule,
    UsersModule,
    PrivateComponent,
  ],
  exports: [PrivateComponent],
})
export class PrivateModule {}
